// src/config/standards/computerScience.js
// Computer Science standards aligned to CSTA K–12 (2017/2020)

export const COMPUTER_SCIENCE_STANDARDS = {
  "Computer Science": {
    // =========================
    // K — 2  (CSTA Level 1A)
    // =========================
    "Kindergarten": {
      "Computing Systems": [
        { id: "CS-K-1A-CS-01", code: "1A-CS-01", description: "Use common input/output devices and explain uses." },
        { id: "CS-K-1A-CS-02", code: "1A-CS-02", description: "Use a computer to complete varied simple tasks." },
        { id: "CS-K-1A-CS-03", code: "1A-CS-03", description: "Describe basic parts of hardware and software." }
      ],
      "Networks & the Internet": [
        { id: "CS-K-1A-NI-04", code: "1A-NI-04", description: "Explain that computers connect to share information." }
      ],
      "Data & Analysis": [
        { id: "CS-K-1A-DA-05", code: "1A-DA-05", description: "Collect and sort data in different ways." },
        { id: "CS-K-1A-DA-06", code: "1A-DA-06", description: "Use simple visualizations to show data." },
        { id: "CS-K-1A-DA-07", code: "1A-DA-07", description: "Identify patterns in data to answer questions." }
      ],
      "Algorithms & Programming": [
        { id: "CS-K-1A-AP-08", code: "1A-AP-08", description: "Describe daily steps as algorithms." },
        { id: "CS-K-1A-AP-09", code: "1A-AP-09", description: "Model a solution as ordered steps." },
        { id: "CS-K-1A-AP-10", code: "1A-AP-10", description: "Create programs with sequences and loops." },
        { id: "CS-K-1A-AP-11", code: "1A-AP-11", description: "Break tasks into smaller steps." },
        { id: "CS-K-1A-AP-12", code: "1A-AP-12", description: "Make programs that use events." },
        { id: "CS-K-1A-AP-13", code: "1A-AP-13", description: "Give credit when using others’ ideas or media." },
        { id: "CS-K-1A-AP-14", code: "1A-AP-14", description: "Find and fix simple program bugs." },
        { id: "CS-K-1A-AP-15", code: "1A-AP-15", description: "Describe choices made while coding." }
      ],
      "Impacts of Computing": [
        { id: "CS-K-1A-IC-16", code: "1A-IC-16", description: "Describe how people use computing at home/school." },
        { id: "CS-K-1A-IC-17", code: "1A-IC-17", description: "Work respectfully and responsibly online." },
        { id: "CS-K-1A-IC-18", code: "1A-IC-18", description: "Keep personal information private." }
      ]
    },
    "1st Grade": {},
    "2nd Grade": {},
    // (K–2 share the same Level 1A expectations)
  }
};

// Copy K–2 arrays into Grade 1 and Grade 2
["1st Grade","2nd Grade"].forEach(g => {
  COMPUTER_SCIENCE_STANDARDS["Computer Science"][g] = JSON.parse(
    JSON.stringify(COMPUTER_SCIENCE_STANDARDS["Computer Science"]["Kindergarten"])
  );
});

// =========================
// 3 — 5  (CSTA Level 1B)
// =========================
Object.assign(COMPUTER_SCIENCE_STANDARDS["Computer Science"], {
  "3rd Grade": {
    "Computing Systems": [
      { id: "CS-3-1B-CS-01", code: "1B-CS-01", description: "Describe how computers process input and output." },
      { id: "CS-3-1B-CS-02", code: "1B-CS-02", description: "Model how hardware and software work together." },
      { id: "CS-3-1B-CS-03", code: "1B-CS-03", description: "Explain how users control computing systems." }
    ],
    "Networks & the Internet": [
      { id: "CS-3-1B-NI-04", code: "1B-NI-04", description: "Model how data moves across networks." },
      { id: "CS-3-1B-NI-05", code: "1B-NI-05", description: "Explain ways to protect devices and data." }
    ],
    "Data & Analysis": [
      { id: "CS-3-1B-DA-05", code: "1B-DA-05", description: "Give examples of problems solved with data." },
      { id: "CS-3-1B-DA-06", code: "1B-DA-06", description: "Organize and present data with visuals." },
      { id: "CS-3-1B-DA-07", code: "1B-DA-07", description: "Use data patterns to answer questions." }
    ],
    "Algorithms & Programming": [
      { id: "CS-3-1B-AP-08", code: "1B-AP-08", description: "Compare and refine multiple algorithms." },
      { id: "CS-3-1B-AP-09", code: "1B-AP-09", description: "Create programs with sequences, events, loops." },
      { id: "CS-3-1B-AP-10", code: "1B-AP-10", description: "Use variables to store and update data." },
      { id: "CS-3-1B-AP-11", code: "1B-AP-11", description: "Decompose problems and plan solutions." },
      { id: "CS-3-1B-AP-12", code: "1B-AP-12", description: "Develop programs for different users’ needs." },
      { id: "CS-3-1B-AP-13", code: "1B-AP-13", description: "Break programs into manageable parts." },
      { id: "CS-3-1B-AP-14", code: "1B-AP-14", description: "Test and debug to improve programs." },
      { id: "CS-3-1B-AP-15", code: "1B-AP-15", description: "Give attribution; follow use permissions." }
    ],
    "Impacts of Computing": [
      { id: "CS-3-1B-IC-16", code: "1B-IC-16", description: "Describe positive and negative tech impacts." },
      { id: "CS-3-1B-IC-17", code: "1B-IC-17", description: "Practice safe, respectful online behavior." },
      { id: "CS-3-1B-IC-18", code: "1B-IC-18", description: "Discuss ownership and sharing of creations." }
    ]
  },
  "4th Grade": {},
  "5th Grade": {}
});

// Copy 3–5 arrays into Grades 4 and 5
["4th Grade","5th Grade"].forEach(g => {
  COMPUTER_SCIENCE_STANDARDS["Computer Science"][g] = JSON.parse(
    JSON.stringify(COMPUTER_SCIENCE_STANDARDS["Computer Science"]["3rd Grade"])
  );
});

// =========================
// 6 — 8  (CSTA Level 2)
// =========================
Object.assign(COMPUTER_SCIENCE_STANDARDS["Computer Science"], {
  "6th Grade": {
    "Computing Systems": [
      { id: "CS-6-2-CS-01", code: "2-CS-01", description: "Recommend improvements after trying systems." },
      { id: "CS-6-2-CS-02", code: "2-CS-02", description: "Model system inputs, processes, and outputs." },
      { id: "CS-6-2-CS-03", code: "2-CS-03", description: "Integrate hardware/software to collect and show data." }
    ],
    "Networks & the Internet": [
      { id: "CS-6-2-NI-04", code: "2-NI-04", description: "Explain common security risks and defenses." },
      { id: "CS-6-2-NI-05", code: "2-NI-05", description: "Describe encryption and authentication basics." },
      { id: "CS-6-2-NI-06", code: "2-NI-06", description: "Use models to explain protocols and reliability." }
    ],
    "Data & Analysis": [
      { id: "CS-6-2-DA-07", code: "2-DA-07", description: "Collect data; judge precision and fairness." },
      { id: "CS-6-2-DA-08", code: "2-DA-08", description: "Build models from data to make predictions." },
      { id: "CS-6-2-DA-09", code: "2-DA-09", description: "Refine models to improve accuracy." }
    ],
    "Algorithms & Programming": [
      { id: "CS-6-2-AP-10", code: "2-AP-10", description: "Plan with flowcharts or pseudocode." },
      { id: "CS-6-2-AP-11", code: "2-AP-11", description: "Create programs with variables and types." },
      { id: "CS-6-2-AP-12", code: "2-AP-12", description: "Iteratively develop programs with user input." },
      { id: "CS-6-2-AP-13", code: "2-AP-13", description: "Decompose and design modular solutions." },
      { id: "CS-6-2-AP-14", code: "2-AP-14", description: "Write procedures/functions with parameters." },
      { id: "CS-6-2-AP-15", code: "2-AP-15", description: "Generalize code for reuse; avoid repetition." },
      { id: "CS-6-2-AP-16", code: "2-AP-16", description: "Use libraries; justify their selection." },
      { id: "CS-6-2-AP-17", code: "2-AP-17", description: "Test systematically; recommend improvements." },
      { id: "CS-6-2-AP-18", code: "2-AP-18", description: "Collaborate using version control practices." },
      { id: "CS-6-2-AP-19", code: "2-AP-19", description: "Document programs for users and developers." }
    ],
    "Impacts of Computing": [
      { id: "CS-6-2-IC-20", code: "2-IC-20", description: "Explain computing’s impact on society." },
      { id: "CS-6-2-IC-21", code: "2-IC-21", description: "Discuss tradeoffs and potential biases in tech." },
      { id: "CS-6-2-IC-22", code: "2-IC-22", description: "Describe risks of unauthorized data access." },
      { id: "CS-6-2-IC-23", code: "2-IC-23", description: "Explain laws/ethics for data and media use." }
    ]
  },
  "7th Grade": {},
  "8th Grade": {}
});

// Copy 6–8 arrays into Grades 7 and 8
["7th Grade","8th Grade"].forEach(g => {
  COMPUTER_SCIENCE_STANDARDS["Computer Science"][g] = JSON.parse(
    JSON.stringify(COMPUTER_SCIENCE_STANDARDS["Computer Science"]["6th Grade"])
  );
});

// =========================
// HIGH SCHOOL
// Clustered inside each domain
// HS—9–10 (CSTA Level 3A) and HS—11–12 (CSTA Level 3B)
// =========================
COMPUTER_SCIENCE_STANDARDS["Computer Science"]["High School"] = {
  "Computing Systems": {
    "HS—9–10 (3A)": [
      { id: "CS-HS-3A-CS-01", code: "3A-CS-01", description: "Explain functions of system components." },
      { id: "CS-HS-3A-CS-02", code: "3A-CS-02", description: "Use OS features; troubleshoot common issues." },
      { id: "CS-HS-3A-CS-03", code: "3A-CS-03", description: "Compare troubleshooting strategies." }
    ],
    "HS—11–12 (3B)": [
      { id: "CS-HS-3B-CS-01", code: "3B-CS-01", description: "Categorize roles of operating systems." },
      { id: "CS-HS-3B-CS-02", code: "3B-CS-02", description: "Explain logic I/O via hardware components." }
    ]
  },

  "Networks & the Internet": {
    "HS—9–10 (3A)": [
      { id: "CS-HS-3A-NI-04", code: "3A-NI-04", description: "Describe issues affecting network performance." },
      { id: "CS-HS-3A-NI-05", code: "3A-NI-05", description: "Explain cybersecurity risks and defenses." }
    ],
    "HS—11–12 (3B)": [
      { id: "CS-HS-3B-NI-03", code: "3B-NI-03", description: "Explain factors that impact network function." },
      { id: "CS-HS-3B-NI-04", code: "3B-NI-04", description: "Compare ways to protect devices and data." }
    ]
  },

  "Data & Analysis": {
    "HS—9–10 (3A)": [
      { id: "CS-HS-3A-DA-11", code: "3A-DA-11", description: "Create interactive visualizations from data." },
      { id: "CS-HS-3A-DA-12", code: "3A-DA-12", description: "Evaluate privacy and data-protection needs." }
    ],
    "HS—11–12 (3B)": [
      { id: "CS-HS-3B-DA-05", code: "3B-DA-05", description: "Analyze complex data to find patterns." }
    ]
  },

  "Algorithms & Programming": {
    "HS—9–10 (3A)": [
      { id: "CS-HS-3A-AP-13", code: "3A-AP-13", description: "Use variables and collections in solutions." },
      { id: "CS-HS-3A-AP-14", code: "3A-AP-14", description: "Create procedures with parameters." },
      { id: "CS-HS-3A-AP-15", code: "3A-AP-15", description: "Combine control and data structures." },
      { id: "CS-HS-3A-AP-16", code: "3A-AP-16", description: "Design and evaluate algorithms." },
      { id: "CS-HS-3A-AP-17", code: "3A-AP-17", description: "Use and adapt libraries and APIs." },
      { id: "CS-HS-3A-AP-18", code: "3A-AP-18", description: "Build artifacts using data and procedures." },
      { id: "CS-HS-3A-AP-19", code: "3A-AP-19", description: "Analyze program correctness and efficiency." },
      { id: "CS-HS-3A-AP-20", code: "3A-AP-20", description: "Consider licenses when using libraries/media." },
      { id: "CS-HS-3A-AP-21", code: "3A-AP-21", description: "Create clear user and developer docs." }
    ],
    "HS—11–12 (3B)": [
      { id: "CS-HS-3B-AP-10", code: "3B-AP-10", description: "Use and adapt classic algorithms." },
      { id: "CS-HS-3B-AP-11", code: "3B-AP-11", description: "Evaluate algorithm efficiency and limits." },
      { id: "CS-HS-3B-AP-24", code: "3B-AP-24", description: "Compare languages and their use cases." }
      // NOTE: Additional 3B AP codes exist; include as needed in your curriculum.
    ]
  },

  "Impacts of Computing": {
    "HS—9–10 (3A)": [
      { id: "CS-HS-3A-IC-23", code: "3A-IC-23", description: "Analyze benefits and harms of innovations." },
      { id: "CS-HS-3A-IC-24", code: "3A-IC-24", description: "Evaluate privacy and security implications." },
      { id: "CS-HS-3A-IC-25", code: "3A-IC-25", description: "Discuss legal and ethical computing issues." },
      { id: "CS-HS-3A-IC-27", code: "3A-IC-27", description: "Explain tradeoffs in data collection/use." },
      { id: "CS-HS-3A-IC-28", code: "3A-IC-28", description: "Consider equity, access, and bias in tech." }
    ],
    "HS—11–12 (3B)": [
      { id: "CS-HS-3B-IC-26", code: "3B-IC-26", description: "Evaluate equity and access in global context." },
      { id: "CS-HS-3B-IC-28", code: "3B-IC-28", description: "Debate laws and regulations in computing." }
      // Add any additional 3B IC codes you teach.
    ]
  }
};

export default COMPUTER_SCIENCE_STANDARDS;
